import { Edit, EllipsisVertical, Trash2 } from "lucide-react";
import React, { MouseEvent } from "react";
import { useImmer } from "use-immer";

import { IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { Menu, MenuItem } from "@mui/material";

interface WidgetMoreMenuProps {
  onEdit: () => void;
  onDelete: () => void;
}

export const WidgetMoreMenu = ({ onEdit, onDelete }: WidgetMoreMenuProps) => {
  const [anchorEl, setAnchorEl] = useImmer<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit();
    handleClose();
  };

  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <>
      <IgIconButton onClick={handleClick} size="small">
        <EllipsisVertical size={16} />
      </IgIconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleEdit}>
          <IgTypography>Edit component</IgTypography>
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <IgTypography>Delete</IgTypography>
        </MenuItem>
      </Menu>
    </>
  );
};
